module.exports = __webpack_public_path__ + "img/version_img4.bf0f16c7.png";